import { Link } from 'react-router-dom';
import { getAllArticles } from '@/pages/article/data';

export default function PillarArticles() {
  const allArticles = getAllArticles();

  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-accent-100 rounded-full px-4 py-1.5 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-accent-700 uppercase tracking-wide">Pillar Articles</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Complete Basetao Spreadsheet Resource Library
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto leading-relaxed">
            In-depth guides covering every aspect of the Basetao spreadsheet — from beginner tutorials and product discovery to shipping strategies, cost breakdowns, and safety verification.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {allArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-white border-2 border-background-200/80 rounded-xl overflow-hidden hover:border-primary-300 hover:shadow-lg transition-all duration-300 flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-white/90 backdrop-blur-sm text-xs font-semibold text-primary-600 px-2.5 py-1 rounded-full">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center gap-1.5 mt-4 text-xs font-medium text-primary-500">
                  Read Article
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-white font-semibold text-base px-8 py-3.5 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/20 hover:shadow-primary-500/35"
          >
            Explore Basetao Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}